const scrollToActive = ($gallery, smooth = true) => {
    const $slider = $gallery.find('[data-gallery-slider]');
    const $currentPage = $gallery.find('[data-gallery-current-page]');
    const $activeSlide = $gallery.find('[data-gallery-slide][data-active="1"]');
    const $leftControl = $gallery.find('[data-gallery-control-left]');
    const $rightControl = $gallery.find('[data-gallery-control-right]');
    const index = $activeSlide.index();
    const slideCount = $gallery.find('[data-gallery-slide]').length;
    const newLeft = $activeSlide.position().left;

    $slider.get(0).scrollTo({
        left: Math.round(newLeft),
        behavior: smooth ? 'smooth' : 'instant',
    });

    $currentPage.text(index + 1);

    if (index === 0) {
        $leftControl.attr('disabled', '');
    }
    else if (index === slideCount - 1) {
        $rightControl.attr('disabled', '');
    }
    else {
        $leftControl.removeAttr('disabled');
        $rightControl.removeAttr('disabled');
    }
};

const goToNextSlide = ($gallery) => {
    const slideCount = $gallery.find('[data-gallery-slide]').length;
    const $activeSlide = (
        $gallery.find('[data-gallery-slide][data-active="1"]')
    );
    const index = $activeSlide.index();
    const nextIndex = index + 1;

    if (nextIndex >= slideCount) return;

    const $nextSlide = $gallery.find('[data-gallery-slide]').eq(nextIndex);

    $activeSlide.removeAttr('data-active');
    $nextSlide.attr('data-active', 1);

    scrollToActive($gallery);
};

const goToPreviousSlide = ($gallery) => {
    const slideCount = $gallery.find('[data-gallery-slide]').length;
    const $activeSlide = (
        $gallery.find('[data-gallery-slide][data-active="1"]')
    );
    const index = $activeSlide.index();
    const previousIndex = index - 1;

    if (previousIndex < 0) return;

    const $previousSlide = (
        $gallery.find('[data-gallery-slide]').eq(previousIndex)
    );

    $activeSlide.removeAttr('data-active');
    $previousSlide.attr('data-active', 1);

    scrollToActive($gallery);
};

const initialize = () => {

    $('[data-gallery] [data-gallery-control-left]').click(function() {
        const $gallery = $(this).parents('[data-gallery]');
        goToPreviousSlide($gallery);
    });

    $('[data-gallery] [data-gallery-control-right]').click(function() {
        const $gallery = $(this).parents('[data-gallery]');
        goToNextSlide($gallery);
    });

    $(window).resize(() => {
        $('[data-gallery]').each(function() {
            scrollToActive($(this));
        });
    });
};

export default {
    initialize,
};

